import { get } from 'object-path';
import { OrderItem } from '../';
import { CustomPrint } from '../CustomPrint';

export function getPrintColor(item: OrderItem): string {
  const color = get(item.printMeta, 'theme.primaryColor', '').toLowerCase();

  return (item as CustomPrint).colorMap?.[color]?.name || '';
}
